module.exports = __webpack_public_path__ + "static/img/11.eb37d0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/11.png
// module id = xiir
// module chunks = 0